import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ListItem } from '@frontend-site/ui/components';
import { TranslateService } from '@ngx-translate/core';
import { CommonGridStandardRowHeightService } from './common-grid-standard-row-height.service';
import { commonGridStandardRowHeightOptions } from './standard-row-height';

@Component({
    selector: 'p-common-grid-select-row-height-button',
    template: `
        <ng-container *ngLet="selectedRowHeight$ | async as selectedRowHeight">
            <p-action-button
                iconBeforeName="row-height"
                iconBeforeSize="md"
                [isStandalone]="false"
                #menuTrigger="matMenuTrigger"
                [isMenuTrigger]="true"
                [matMenuTriggerFor]="optionsMenu"
                [matTooltip]="'Execution.MainTabStrip.Steps.Toolbar.select_row_height' | translate"
            ></p-action-button>

            <mat-menu #optionsMenu="matMenu" class="no-padding p-menu p-menu-single">
                <ng-template matMenuContent>
                    <p-picker-single-select
                        [value]="selectedRowHeight?.height"
                        [iconsPosition]="'left'"
                        [canSearch]="false"
                        [list]="menuList"
                        (valueChange)="optionSelected($event); optionsMenu.closed.emit()"
                    ></p-picker-single-select>
                </ng-template>
            </mat-menu>
        </ng-container>
    `,
    styleUrls: ['./select-row-height-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectRowHeightButtonComponent implements OnInit {
    protected selectedRowHeight$ = this.commonGridStandardRowHeightService.rowHeight$; //.pipe(
    protected menuList: ListItem[] = [];

    protected optionSelected(e: any): void {
        const selectedRowHeight = commonGridStandardRowHeightOptions.find((option) => option.height === +e);
        if (selectedRowHeight) {
            this.commonGridStandardRowHeightService.setHeight(selectedRowHeight);
        }
    }

    constructor(
        private readonly translate: TranslateService,
        private readonly commonGridStandardRowHeightService: CommonGridStandardRowHeightService
    ) {}

    ngOnInit(): void {
        commonGridStandardRowHeightOptions.forEach((option) =>
            this.menuList.push({
                id: option.height,
                name: this.translate.instant(option.translateKey),
                iconName: option.iconName
            })
        );
    }
}
